import { render, staticRenderFns } from "./FinancialItem.vue?vue&type=template&id=e52435c8&scoped=true&"
import script from "./FinancialItem.vue?vue&type=script&lang=js&"
export * from "./FinancialItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52435c8",
  null
  
)

export default component.exports